import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Healthz from './components/healthz'; // adjust the path to point to your Healthz component

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/healthz" element={<Healthz />} />
      </Routes>
    </Router>
  );
};

export default App;
